import { render, staticRenderFns } from "./feature-card-power.vue?vue&type=template&id=7b09f6fa&scoped=true&"
import script from "./feature-card-power.vue?vue&type=script&lang=js&"
export * from "./feature-card-power.vue?vue&type=script&lang=js&"
import style0 from "./feature-card-power.vue?vue&type=style&index=0&id=7b09f6fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b09f6fa",
  null
  
)

export default component.exports